// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n.app-main[data-v-e64c493e] {\n  /* 50= navbar  50  */\n  min-height: calc(100vh - 250px);\n  margin: 0 auto;\n  position: relative;\n  overflow: auto;\n  overflow-x: hidden;\n}", ""]);
// Exports
module.exports = exports;
